import React from "react";
import "../Style/Component/Profile.css";
import image from "../Assets/Account/7e751d11f30fc3b155d92b1f20a344fe52513f13.jpg";
import backIcon from "../Assets/Account/back.svg";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { profile } from "../Store/authSlicer";
const Profile = ({ profiledata }) => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  return (
    <div className="accountprofile">
      {/* Back Button */}
      <img
        src={backIcon}
        className="back-btn"
        alt="back"
        onClick={() => navigate(-1)}
      />

      <div className="accountprofileimage">
        <img src={profiledata?.profileimage} alt="profile" />
      </div>

      {/* Name */}
      <span className="accountprofilename">{profiledata?.name}</span>
      <span className="accountprofilesuffixname">{profiledata?.roletype}</span>

      {/* White Card */}
      <div className="accountprofileform">
        <div className="accountfield">
          <label>Phone number</label>
          <input type="text" value={profiledata?.phoneNumber} readOnly />
        </div>

        <div className="accountfield">
          <label>Email</label>
          <input type="text" value={profiledata?.email} readOnly />
        </div>

        <div className="accountfield">
          <label>Address</label>
          <input
            type="text"
            value={`${profiledata?.location1?.[0]?.city || ""}, ${profiledata?.location1?.[0]?.state || ""}`}
            readOnly
          />
        </div>

        <div className="accountfield">
          <label>Pincode</label>
          <input
            type="text"
            value={profiledata?.location1?.[0]?.pincode}
            readOnly
          />
        </div>
      </div>
    </div>
  );
};

export default Profile;
